// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__faOzp","footer":"ChangeClinic_footer__KijKA"};